import React from 'react';
import * as R from 'ramda';
import { isWeb } from 'utils/util';
import { isWeixinMobile } from 'utils/util';
import { inject, observer } from 'mobx-react';

/**
 * @param props {Object} {
 *   - mobile
 *      - wx
 *      - other
 *   - pc
 *   wxAction
 *   pcAction
 * }
 * @constructor
 */
export const PlatformAuthClickActionWrap = inject('rootStore')(
  observer((props: any) => {
    const is_mock = R.pathOr(
      false,
      ['rootStore', 'wxuserStore', 'user', 'is_mock'],
      props
    );
    const auth = R.pathOr(R.F, ['rootStore', 'wxuserStore', 'auth'], props);
    const children = R.pathOr(null, ['children'], props);
    const wxAction = R.pathOr(R.F, ['wxAction'], props);
    const pcAction = R.pathOr(R.F, ['pcAction'], props);
    return (
      <div
        onClick={() => {
          if (is_mock && Number(window.configDetail.active_on) === 1) {
            auth();
            return;
          }
          if (isWeb()) {
            pcAction();
          } else {
            if (isWeixinMobile()) {
              wxAction();
            } else {
              pcAction();
            }
          }
        }}
      >
        {children}
      </div>
    );
  })
);
